// imported directly to avoid the circular import of fakeDb (sidebars -> pages)
import References from "../../fakeDb/diagnostics/references";
// import { References } from "../../fakeDb";
// import { getDevelopment } from "../";

// const DEFAULT_REFERENCE = {
//   lo: 0,
//   hi: 0,
//   warn: 0,
//   alert: 0,
//   critical: 0,
//   units: "",
//   _id: "",
// };

const findReference = (
  key,
  gender = false,
  dob,
  preference = "",
  preferences = []
) => {
  const getReference = () => {
    let references = {};
    const service = preferences.filter(
      ({ serviceId }) => serviceId === Number(key)
    );
    switch (preference) {
      case "gender":
        // unknown gender falls back to the first reference
        references =
          service.find(({ isMale }) => isMale === gender) ||
          service[0] ||
          null;

        break;
      case "development": {
        // reference of the age group of the patient, otherwise the default (adult)
        const stage = References.getDevelopmentByBirthDate(dob);
        const index = stage
          ? References.getDevelopmentIndexByName(stage.name)
          : -1;
        references =
          service.find(({ development }) => development === index) ||
          service.find(
            ({ development }) => development === undefined || development === null
          ) ||
          service[0] ||
          null;

        break;
      }
      default:
        references =
          preferences.find(({ serviceId }) => serviceId === Number(key)) ||
          null;

        break;
    }

    return references;
  };

  return (
    getReference() || {
      lo: 0,
      hi: 0,
      warn: 0,
      alert: 0,
      critical: 0,
      units: "",
      _id: "",
    }
  );
  // if (!Array.isArray(preferences) || preferences.length === 0) {
  //   return DEFAULT_REFERENCE;
  // }

  // const predicates = {
  //   equal: () => () => true, // always true
  //   gender:
  //     () =>
  //     ({ isMale }) =>
  //       isMale === gender,
  //   development:
  //     () =>
  //     ({ development }) =>
  //       development ===
  //       References.preferences.development.indexOf(getDevelopment(dob)),
  // };

  // const getPredicate = predicates[preference] || predicates.equal;
  // const reference = preferences.find(getPredicate());

  // return reference || DEFAULT_REFERENCE;
};

export default findReference;
